module.exports = __webpack_public_path__ + "img/NeedsLeads.f10a61e3.svg";